export default __webpack_public_path__ + "static/media/11111.a37c4938.jpg";